import React, { useEffect, useRef, useState } from 'react';
import PostContent from './PostContent';
import PostMedia from './PostMedia';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from '../../../../../Features/lensSlice';
import { getSinglePost } from '../../../../../lib/utils/apiCalls';
import { useOutsideClickHandler } from '../../../../../Hooks/useOutsideClick';

function LensPost() {
    const dispatch = useDispatch();
    const [post, setPost] = useState({});
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const selectedPost = useSelector((state) => state.lens.modal.selectedPost);

    useEffect(() => {
        const getPost = async () => {
            try {
                const postData = await getSinglePost(selectedPost.id);
                setPost(postData);
            }
            catch(err) {
                console.log(err);
                dispatch(closeModal());
            }
        }

        getPost();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedPost]);

    return (
        <div ref={wrapperRef} className={`${(post?.imageUrls?.length > 0 || post.videoUrls) ? 'w-3/4 max-[1280px]:w-[85%]' : 'w-[30%] max-[1280px]:w-[40%]'} flex h-[90vh] rounded-3xl overflow-hidden bg-white`}>
            {
                (post?.imageUrls?.length > 0 || post.videoUrls) && 
                <PostMedia 
                    post={post} 
                />
            }

            <PostContent 
                post={post} 
            />
        </div>
    );
}

export default LensPost;
